import { WAITLIST_URL } from 'lib/constants'

export const RUANICA_EXPLORE_NAVIGATION = [
  { anchor: '/ruanica', text: 'Home', options: { sx: { color: 'white' } } },
  { anchor: WAITLIST_URL, text: 'Join waitlist', options: { variant: 'contained' } },
]
